import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import Logout from "../../common/Logout";
import CustomSliderV2 from "../../common/CustomSliderV2";
import CustomModalWrapper from "../../common/CustomModalV2/wrapper";

import SlideWelcomePage from "./components/SlideWelcomePage";
import SlideSuccessPage from "./components/SlideSuccessPage";
import SlideSelectDays from "../user-onboarding/components/SlideSelectDays";
import SlideSelectMinutesPerWeek from "../user-onboarding/components/SlideSelectMinutesPerWeek";
import SlideSelectConsistency from "../user-onboarding/components/SlideSelectConsistency";
import SlideSelectWorkoutLength from "../user-onboarding/components/SlideSelectWorkoutLength";
import SlideSelectProgram from "../user-onboarding/components/SlideSelectProgram";
import SlideLoader from "../user-onboarding/components/SlideLoader";
import SlideWorkoutPlan from "../user-onboarding/components/SlideWorkoutPlan";
import ProgressIndicator from "../user-onboarding/components/ProgressIndicator";

import { GetSurveyGoals, LinkScheduleToUser, LoadAccountDetails, GenerateScheduleOldUser } from "../../redux/v2/user/actions";
import { AddProgram } from "../../redux/v2/user/actions";

import { checkIfUsingMobileApp } from "../../utils/userResource";
import useWorkoutPlan from "../../hooks/useWorkoutPlan";

import { callSocket } from "../../utils/socket";
import { socket, socketS2 } from "../../utils/socket";
import { delay } from "../../utils";
import { genders } from "../../constants";

import "./style.css";

function OnboardingV2(props) {
    const { page } = useParams();
    const navigate = useNavigate();


    const platform = new URLSearchParams(window.location.search).get("platform");
    const sessionID = new URLSearchParams(window.location.search).get("session_id");
    if ((platform != null && platform != "null")) {
        localStorage.setItem("indi-platform", platform);
    }
    if ((sessionID != null && sessionID != "null")) {
        localStorage.setItem("indi-native-session", sessionID);
    }
    const lsSessionID = localStorage.getItem("indi-native-session");

    const isUsingMobileApp = checkIfUsingMobileApp();
    const sliderRef = useRef(null);
    const [wpProgress, setWPProgress] = useState({ progress: 0, message: "Working on it" });
    const [surveySentStatus, setSurveySentStatus] = useState(0);
    const [slide, setSlide] = useState(page ? parseInt(page) : 0);
    const [showIndicator, setShowIndicator] = useState(true);
    const [scheduleID, setScheduleID] = useState(null);
    const [userID, setUserID] = useState(null);
    const [addedPrograms, setAddedPrograms] = useState([]);
    const [preRegistrationDetails, setPreRegistrationDetails] = useState({
        personalInfo: {
            firstName: "",
            lastName: "",
            dob: "",
            gender: "",
        },
        daysToWorkout: [],
        minutesPerWeek: "",
        consistency: "",
        preferedWorkoutLength: "",
        goals: [],
        programs: [],
    });
    const { surveyGoals, account } = props?.User;
    const { programs } = props?.Program;
    const { workoutPlan } = useWorkoutPlan({ account, programs });

    const moveNext = (e, pSlide = null) => {
        let s = pSlide || (slide + 1);
        sliderRef?.current?.slickGoTo(s);
        setSlide(ps => ps = s);
    }

    const moveBack = (e, pSlide = null) => {
        let s = pSlide || (slide - 1);
        sliderRef?.current?.slickGoTo(s);
        setSlide(ps => ps = s);
    }

    const backLogin = () => {
        if (isUsingMobileApp) {
            callSocket(`interact-onboarding`, { type: "back-login", sessionID: lsSessionID });
        } else {
            navigate("/login");
        }
    }

    const addNewPrograms = (programs) => {
        for (let x = 0; x < programs.length; x++) {
            props.AddProgram(programs[x]?.id, programs[x]?.level);
        }

    }

    const slideSelectProgramMoveNext = async (allAddedPrograms) => {

        moveNext();

        const payload = {
            ...preRegistrationDetails,
            personalInfo: {
                dob: account?.user?.dob,
                firstName: account?.user?.first_name,
                gender: genders[account?.user?.gender],
                lastName: account?.user?.last_name,
            },
            programs: allAddedPrograms
        };

        addNewPrograms(allAddedPrograms?.filter(p => p?.isNew));
        const res = await props?.GenerateScheduleOldUser(payload);

        if (res) {
            await props?.LoadAccountDetails();
            // navigate("/home");
            setSurveySentStatus(1)
        } else {
            setSurveySentStatus(-1)
            // moveBack();
        }

    }

    const ListenWPProgress = (id) => {
        socketS2.removeAllListeners(`update-workout-plan-generate-progress-${id}`);
        socketS2.on(`update-workout-plan-generate-progress-${id}`, (data) => {
            setWPProgress(data?.data);
        });
    };

    useEffect(() => {
        if (surveySentStatus == 1) {
            delay(() => {
                moveNext();
            }, 1000)
        } else if (surveySentStatus == -1) {
            moveBack();
        }
    }, [surveySentStatus]);

    useEffect(() => {
        props.GetSurveyGoals();
    }, []);

    useEffect(() => {
        // const link = (process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_APP_URL : "http://localhost:3001/");
        const link = (process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_APP_URL : process.env.REACT_APP_APP_URL_DEV);
        window?.history?.pushState({}, "", `${link}user-survey/${slide}`);
    }, [slide]);


    useEffect(() => {
        account?.user?.id && ListenWPProgress(account?.user?.id);
    }, [account?.user?.id]);


    useEffect(() => {
        const cb = async () => {
            if (scheduleID && userID) {
                await props.LinkScheduleToUser(scheduleID, userID);
                await props.LoadAccountDetails();
                delay(() => {
                    if (isUsingMobileApp) {
                        callSocket(`interact-onboarding`, { type: "set-token", sessionID: lsSessionID, token: localStorage.getItem("temp-access-token") });
                    } else {
                        moveNext({}, slide + 1);
                    }
                }, 2000)
            }
        }

        cb();
    }, [scheduleID, userID]);

    const hideConsistency = preRegistrationDetails?.minutesPerWeek == "0 Mins";
    let hidden = 0;
    if (hideConsistency) hidden++;



    return (
        <div id="user-onboarding" className="user-survey">
            <Logout showLogo backAction={(slide != (6 - hidden) && slide != (7 - hidden)) ? () => {
                if (slide == 0) {
                    backLogin();
                } else {
                    moveBack();
                }
            } : null} />
            <CustomSliderV2
                id="uo-custom-slider"
                sliderRef={sliderRef}
                swipe={false}
                draggable={false}
                afterChange={(current) => {
                    setSlide(current);
                }}
                initialSlide={parseInt(page)}
            >
                <SlideWelcomePage preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} backLogin={backLogin} />
                <SlideSelectDays preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} />
                <SlideSelectMinutesPerWeek preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} />
                {!hideConsistency && <SlideSelectConsistency preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} />}
                <SlideSelectWorkoutLength preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} />
                <SlideSelectProgram setAddedPrograms={setAddedPrograms} displayType={3} preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={slideSelectProgramMoveNext} setShowIndicator={setShowIndicator} setScheduleID={setScheduleID} />
                <SlideLoader preRegistrationDetails={preRegistrationDetails} setPreRegistrationDetails={setPreRegistrationDetails} moveNext={moveNext} showProgress={true} wpProgress={wpProgress} isPageActive={slide == (6 - hidden)} />
                <SlideSuccessPage moveNext={() => {
                    navigate("/home");
                }} />
                {/* <SlideWorkoutPlan workoutPlan={workoutPlan} moveNext={moveNext} /> */}
            </CustomSliderV2>

            <CustomModalWrapper />
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    Program: state.Program,
});

export default connect(mapStateToProps, {
    GetSurveyGoals,
    LinkScheduleToUser,
    LoadAccountDetails,
    GenerateScheduleOldUser,
    AddProgram,
})(OnboardingV2);
